/**
 * @fileoverview Hook to access dashboard data context.
 * @module shared/hooks/dashboard/useDashboardData
 */

import { useContext } from 'react'
import {
  DashboardDataContext,
  DashboardDataContextType,
} from '@/shared/context/DashboardDataContext'

/**
 * Hook to access dashboard data context.
 *
 * @returns Dashboard data context
 * @throws Error if used outside DashboardDataProvider
 * @example
 * ```typescript
 * const { ecommerceQuery, productsQuery, isLoading } = useDashboardData();
 * ```
 */
export function useDashboardData(): DashboardDataContextType {
  const context = useContext(DashboardDataContext)

  if (!context) {
    throw new Error('useDashboardData must be used within DashboardDataProvider')
  }

  return context
}
